import { useNavigate } from 'react-router-dom';
import { I } from './kit';

// Sticky top bar: optional back chevron, title/sub, and a right-side slot.
// No notification bell here — that lives only on the five tab-root headers.
//
// `title` accepts a node, so a page that wants a collapsing header can pass its
// own crossfading element (see DocumentWorkspacePage).
export default function AppBar({ title, sub, onBack, back, right }) {
  const nav = useNavigate();
  const goBack = onBack || (back ? () => nav(-1) : null);
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 16px', background: 'var(--surface)', borderBottom: '1px solid var(--border)', flex: 'none' }}>
      {goBack && (
        <div onClick={goBack} style={{ width: 36, height: 36, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--text)', flex: 'none' }}>
          <I.back width={20} height={20} />
        </div>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 16, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{title}</div>
        {sub && <div style={{ fontSize: 11.5, color: 'var(--muted)' }}>{sub}</div>}
      </div>
      {right}
    </div>
  );
}
